import axios from "axios";
import { httpClient, reportAxios } from "ultis/axios";

export const getListProvinceType = (params) => {
  return reportAxios.get(`/api/v1/provinces/type`, { params });
};

export const getListContactCenter = (params) => {
  return httpClient.get("/vnpost/contact-center", { params });
};

/** api lấy bưu điện tỉnh thành phố */
const getCityPostOffice = (params) => {
  return httpClient.get("/vnpost/city-post-office", {
    params,
  });
};

/** api lấy bưu điện huyện */
const getListDistrictPostOffice = (params) => {
  return httpClient.get("/vnpost/district-post-office", {
    params,
  });
};

/** api danh sách bộ phận (bưu cục) */
const getListProvince = (params) => {
  return httpClient.get("/vnpost/province", {
    params,
  });
};

/**api lấy địa chỉ ip của người dùng */
const getClientIpAddressFromBeexVn = async () => {
  return axios.get("https://core2.beex.vn:8089/checkIp", {
    timeout: 2000,
  });
};

export const CommonApi = {
  getListProvince,
  getListProvinceType,
  getListContactCenter,
  getCityPostOffice,
  getListDistrictPostOffice,
  getClientIpAddressFromBeexVn,
};
